module.exports = __webpack_public_path__ + "static/media/times-circle.d587d97b.svg";